import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useSubjectChapters(data = {}) {
  const { enabled = false, queryParams = '', classID, subjectID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getChapters() {
    return privateFetch
      .get(`/v1/admin/class/${classID}/subject/${subjectID}/chapter${queryParams}`)
      .then((res) => res.data);
  }

  return useQuery(['class-subject-chapters', { data }], getChapters, { enabled });
}

export default useSubjectChapters;
